export default __webpack_public_path__ + "static/media/preview-mixed-media.80c8be0c.jpg";